<template>
  <v-container class="signup-image" fluid>
    <v-row style="height: 95vh;" align="center" justify="center">
      <v-col cols="4">
        <v-card class="pa-7 text-center" outlined>
          <v-form v-model="valid">
            <h1 v-html="$t('joinSmartTraders')"></h1>
            <p class="mb-7">{{ $t('createSwisetAccount') }}</p>
            <v-text-field :label="$t('form.firstName.label')" v-model="firstName" :rules="firstNameRule" outlined/>
            <v-text-field :label="$t('form.email.label')" v-model="email" :rules="emailRule" outlined/>
            <v-text-field :label="$t('form.username.label')" v-model="username" :rules="usernameRule" outlined/>
            <v-text-field :label="$t('form.password.label1')" v-model="password" type="password" :rules="passwordRule" outlined/>
            <v-text-field v-if="password !== ''" :label="$t('form.password.label2')" v-model="confirmPassword" type="password" :rules="confirmPasswordRule" outlined/>
            <v-btn :disabled="!valid" @click="submitRegister">{{ $t('submitBtn') }}</v-btn>
            <p class="mt-5 mb-1" v-html="$t('alreadyHaveSwisetAccount')"/>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Repository from '../../../repositories/auth';
import { getRecaptchaToken } from '../../../services/recaptcha';
export default {
  name: "Collapsed",
  data() {
    return {
      landingKey: '',
      firstName: '',
      email: '',
      username: '',
      password: '',
      confirmPassword: '',
      highlight: '',
      discount: 0,

      // Rules
      valid: false,
      firstNameRule: [
        p => !!p || this.$t('form.firstName.rule'),
      ],
      emailRule: [
        e => !!e || this.$t('form.email.rule'),
        e => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e) || 'Invalid email',
      ],
      usernameRule: [
        u => !!u || this.$t('form.username.rule1'),
        u => (u || '' ).length < 35 || this.$t('form.username.rule2'),
        u => !u.includes('@') || this.$t('form.username.rule3'),
        u => !u.includes('&')  || this.$t('form.username.rule4'),
        u => (u.split(' ').length <= 1) || this.$t('form.username.rule5'),
      ],
      passwordRule: [
        p => !!p || this.$t('form.password.rule1'),
        p => (p || '' ).length < 60 || this.$t('form.password.rule2'),
        p => (p || '' ).length > 6 || this.$t('form.password.rule3'),
      ],
      confirmPasswordRule: [
        p => !!p || this.$t('form.password.rule1'),
        p => p === this.password || this.$t('form.password.rule4'),
      ],
    };
  },
  mounted() {
    this.verifyRouteParams();
  },
  methods: {
    verifyRouteParams() {
      if(this.$route.query.landingKey !== undefined)
        this.landingKey = this.$route.query.landingKey;
      if(this.$route.query.highlight !== undefined)
        this.highlight = this.$route.query.highlight;
      if(this.$route.query.discount !== undefined)
        this.discount = this.$route.query.discount;
    },
    async submitRegister() {
      // Get reCAPTCHA token
      const recaptchaToken = await getRecaptchaToken('register_collapsed');
      
      let user = {
        firstName: this.firstName,
        lastName: 'NOT REGISTERED',
        email: this.email,
        username: this.username,
        password: this.password,
        phoneNumber: 'NOT REGISTERED',
        langKey: this.$i18n.locale,
        recaptchaToken: recaptchaToken,
      };

      Repository.existingUsernameOrEmail(this.username, this.email).then((response) => {
        if(response.status < 400 && response.data === -1) {
          Repository.registerCollapsedUser(user).then((secondResponse) => {
            if (secondResponse.status < 400) {
              window.sendinblue.identify(this.email, {
                'NOMBRE': this.firstName,
                'SURNAME' : 'NOT REGISTERED',
                'USERNAME': this.username,
                'PHONE': 'NOT REGISTERED',
                'COUNTRY': 'NOT REGISTERED',
                'PRO_ON' : '0',
                'LANG' : 'en',
                'CHANNEL' : 'PAID_MARKETING',
                'USAGE_STATE': 'PRE_REGISTERED',
                'COMMERCIAL_STATE': 'NEVER_PRO',
              });
              window.fbq('track', 'SubmitApplication');
              window.fbq('trackCustom', 'VirtualPageView',
                  { url: (this.landingKey !== '')? `/pre-registration-by-desktop-${this.landingKey}` : '/pre-registration-by-desktop' });

              // Skip Plans view if there is no highlight param
              if(this.highlight === undefined || this.highlight === '')
                this.$router.push({ name: 'confirmed-email', params: { email: this.email, password: this.password, comeFrom: "Collapsed"} });
              else
                this.$router.push({
                  name: 'subscription-plans-collapsed',
                  params: {
                    userId: Number.parseInt(secondResponse.data.id),
                    highlight: this.highlight,
                    discount: Number.parseInt(this.discount)
                  }
                });
            }
          });
        }
        else
          alert(this.$t('existingAlert'));
      });
    },
  }
}
</script>



<style scoped>
.signup-image{
  padding: 0;
  background-color: #FFFFFF;
  background-image: url("https://hub.swiset.com/wp-content/uploads/2021/06/Swiset-Form-Collapsed.png");
  background-repeat: no-repeat;
  background-size: contain, cover;
  background-position: center;
}
</style>
